<template>
  <div class="motorClause">
    <div class="top">
      <div v-if="JQList !== []" class="jqBox">
        <div class="title" @click="isShowBtn(1)">
          <span>交强险特约</span>
          <van-icon v-show="isShow1" color="#bcbdc1" :name="arrowName" size="22" />
          <van-icon v-show="!isShow1" color="#bcbdc1" :name="arrowName" size="22" />
        </div>
        <div
          v-for="(item, index) in JQListMust"
          v-show="isShow1"
          :key="index"
          class="jqMain"
        >
          <div style="margin-top:.14rem">
            <span>{{ item.clauseName }}</span>
            <span class="must-choose">必选</span>
          </div>
          <p>{{ item.clauseContent }}</p>
        </div>
        <div
          v-for="(item, index) in JQList"
          v-show="isShow1"
          :key="'jq' + index"
          class="jqMain"
          @click="isCheckout(item, index)"
        >
          <div>
            <div class="jqMainTop">
              <div class="jqMainTops">
                <van-icon
                  :name="item.verdict ? 'checked' : 'circle'"
                  :color="item.verdict ? '#5e2589' : ''"
                  size="22"
                />
                <span style="margin-left: 0.05rem">{{ item.clauseName }}</span>
              </div>
              <img
                v-if="item.modifyFlag === '1'"
                :src="img"
                alt=""
                @click.stop="JQShowEdit(index)"
              >
            </div>
            <p>{{ item.clauseContent }}</p>
          </div>
        </div>
      </div>
      <!-- <div class="jqBox">
        <div class="title" @click="isShowBtn(2)">
          <span>商业险特约</span>
          <van-icon v-show="isShow2" :name="arrowName" size="22" />
          <van-icon v-show="!isShow2" :name="arrowName" size="22" />
        </div>
        <div
          v-show="isShow2"
          class="jqMain"
          v-for="(item, index) in 3"
          :key="'jq' + index"
          @change="isCheckout(item, index)"
        >
          <div>
            <div class="jqMainTop">
              <div class="jqMainTops">
                <van-icon
                  :name="true ? 'checked' : 'circle'"
                  :color="true ? '#5e2589' : ''"
                  size="22"
                />
                <span style="margin-left:.05rem;">实际车型约定</span>
              </div>
              <img :src="img" alt="" @click.stop="JQShowEdit(index)"
              />
            </div>
            <p>clauseContent</p>
          </div>
        </div>
      </div> -->
    </div>
    <div class="bottom">
      <div class="btn" @click="nextBtn">
        下一步
      </div>
    </div>
    <van-popup v-model="showEdit" style="border-radius: 7px">
      <div class="edit-contain">
        <div class="text-area">
          <textarea v-model="waitEditContent" />
        </div>
        <div class="btn-area">
          <div style="color: rgba(153, 153, 153, 1)" @click="showEdit = false">
            取消
          </div>
          <div style="color: rgba(94, 37, 137, 1)" @click="confirmEdit">
            确定
          </div>
        </div>
      </div>
    </van-popup>
    <Loading :switchs="switchs" />
  </div>
</template>
<script>
import api from '@/api/api.js'
import { Toast } from 'vant'
import Loading from '@/components/Loadings/Loading'
import { areaDetail } from '@/utils/const'
import { removeWatermark, setWaterMark } from '../../../watermark'
import checkFormat from '@/utils/checkFormat.js'
export default {
  components: {
    Loading: Loading
  },
  data() {
    return {
      isShow1: true,
      isShow2: true,
      checked: false,
      arrowName: 'arrow-up',
      switchs: false,
      img: api.imgAllUrl + '/sales270709.png',
      showEdit: false,
      JQList: [],
      JQListMust: [],
      waitEditContent: '',
      JQKey: '', // 当前选中修改
      comName: '', // 机构名
      comCode: '', // 机构代码
      cInfo: {}
    }
  },
  activated() {
    this.$store.commit('set_showStep', false)
    this.JQList = []
    this.JQListMust = []
    this.getDetail()
    if (localStorage.getItem('cInfo')) {
      this.cInfo = JSON.parse(localStorage.getItem('cInfo'))
      this.cInfo.name = checkFormat.hideInsurantName(1, this.cInfo.name)
      this.cInfo.identifyNum = checkFormat.hideInsurantName(3, this.cInfo.identifyNum)
      setWaterMark(this.cInfo.name + '-' + this.cInfo.identifyNum)
    }
  },
  mounted() {
  // 陕西610000 河南410000
    this.comName = localStorage.getItem('setMotorAreaName')
    areaDetail.forEach(El => {
      if (El.comName === this.comName) {
        this.comCode = El.comCode
      }
    })
  },
  deactivated() {
    removeWatermark()
  },
  methods: {
    getDetail() {
      // 进入页面参数
      const param = {
        orderId: this.$store.state.motorOrderId,
        // provinceCode: this.$store.state.proposalAreaCode,
        provinceCode: this.comCode,
        riskCode: '0591' // 险种代码（0591-交强/0501-商业）
      }
      // console.log(this.$store.state.engageList, 'this.$store.state.engageList')
      this.switchs = true
      this.$http
        .post(api.queryClauseData, param)
        .then((res) => {
          Toast.clear()
          this.switchs = false
          if (res.data.rtnCode === '0000') {
            console.log(res.data)
            const returnData = res.data.resultObj
            returnData.forEach((item) => { // item.optType--1可选/2必选不可取消/3默认勾选可取消
              if (item.clauseType === '2' && item.optType === '3') {
                item.verdict = true
                this.JQList.push(item)
              } else if (item.clauseType === '2' && item.optType === '1') {
                item.verdict = false
                if (
                  this.$store.state.engageList &&
                  this.$store.state.engageList !== ''
                ) {
                  this.$store.state.engageList.forEach((EL) => {
                    if (EL.clauseCode === item.clauseCode) {
                      item.verdict = true
                    }
                  })
                }
                this.JQList.push(item)
              } else if (item.clauseType === '2' && item.optType === '2') {
                this.JQListMust.push(item)
              }
            })
            console.log(this.JQListMust, this.JQList, '没懂')
          } else {
            this.switchs = false
            this.$toast(res.data.rtnMsg)
          }
        })
        .catch((error) => {
          Toast.clear()
          console.log(error)
          this.switchs = false
        })
    },
    nextBtn() { // 下一步
      const arr = []
      const arrClause = []
      if (this.JQList !== []) {
        this.JQList.forEach(item => {
          if (item.verdict) {
            const obj = {
              clauseCode: item.clauseCode,
              clauseName: item.clauseName,
              clauses: item.clauseContent,
              riskCode: item.riskCode,
              proType: item.optType
            }
            arr.push(obj)
            obj.clauseId = item.clauseId
            arrClause.push(obj)
          }
        })
      }
      if (this.JQListMust !== []) {
        this.JQListMust.forEach(item => {
          const obj = {
            clauseCode: item.clauseCode,
            clauseName: item.clauseName,
            clauses: item.clauseContent,
            riskCode: item.riskCode,
            proType: item.optType
          }
          arr.push(obj)
          obj.clauseId = item.clauseId
          arrClause.push(obj)
        })
      }
      // console.log(arr,'what');
      this.$store.commit('setEngageList', arrClause)
      this.$router.replace({
        name: 'MotorSupplementary',
        params: {
          result: arrClause
        }
      })
      const data = {
        orderId: this.$store.state.motorOrderId,
        engageList: arr,
        terminalId: 'H5',
        orderOrigin: 'DP_OWXPA',
        channelCode: 'DP_OWXPA',
        vehicleInfo: this.$store.state.motorBaseInfo
      }
      this.switchs = true
      this.$http.post(api.motorSava, data)
        .then(res => {
          this.switchs = false
          if (res.data.rtnCode === '0000') {
            this.$store.commit('setEngageList', arr)
            this.$router.push('/motor/motorSupplementary')
          } else {
            this.$toast(res.data.rtnMsg)
          }
        })
        .catch(error => {
          console.log(error)
          this.switchs = false
        })
    },
    isShowBtn(index) {
      const isShow = 'isShow' + index
      this[isShow] = !this[isShow]
      const arrowName = 'arrowName' + index
      this[arrowName] = this[isShow] ? 'arrow-up' : 'arrow-down'
    },
    isCheckout(item, index) {
      item.verdict = !item.verdict
    },
    JQShowEdit(index) {
      this.JQKey = index
      this.showEdit = true
      this.waitEditContent = this.JQList[index].clauseContent
    },
    confirmEdit() {
      this.JQList[this.JQKey].clauseContent = this.waitEditContent
      this.showEdit = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./motorClause.scss";
</style>



// WEBPACK FOOTER //
// src/pages/motor/components/supplementary/motorClause/index.vue